export enum HighlightStatus {
  ok,
  warning
}
